import React, { useEffect, useState } from 'react';
import CustomText from '../../../Common/customComponents/CustomText.tsx';
import {
  commonMsg,
  companyUtil,
  dateUtil,
  format,
  systemCdUtil
} from '../../../../utils/globalUtil.tsx';
import CustomButton from '../../../Common/customComponents/CustomButton.tsx';

import SampleMapImage from '/assets/icon/global/sample-map-image.svg';
import CustomSelectSingle from '../../../Common/customComponents/CustomSelectSingle.tsx';
import CustomDatetime from '../../../Common/customComponents/CustomDatetime.tsx';
import CustomNumber from '../../../Common/customComponents/CustomNumber.tsx';
import FormApproval from './approval/FormApproval.tsx';
import CustomTextarea from '../../../Common/customComponents/CustomTextarea.tsx';
import PermitIssueForm from './PermitIssueForm.tsx';
import CustomDate from '../../../Common/customComponents/CustomDate.tsx';
import { ptwApi } from '../../../../api/ptw.api.ts';
import { safObjectHelper } from 'utils/SafObjectHelper.ts';
import PermitIssueMap from './PermitIssueMap.tsx';
import WorkLocationModal from '../modal/WorkLocationModal.tsx';
import { useAsync, useUser } from '../../../../hooks';
import { codeApi } from '../../../../api/code.api.ts';
import CustomUploader from 'containers/Common/customComponents/CustomUploader.tsx';
import DashIcon from '/assets/icon/global/cancel.svg';
import ClockIcon from '/assets/icon/global/extension.svg';
import ActionClock from '/assets/icon/global/action-clock.svg';
import ExtensionHistoryModal from '../modal/ExtensionHistoryModal.tsx';

interface IProps {
  data: any;
  setData: any;
  handleChange: any;
  formCode: string;
  isReadOnly: boolean;
  userInfo: any;
  isFinish: boolean;
  tbmNo?: string;
}

const Form04RoadDetail = (props: IProps) => {
  const { showAlarm, closeAlarm } = useAsync();
  const user = useUser();
  /*공통코드*/
  const [disciplineCdList, setDisciplineCdList] = useState<any>([]);
  const [workCdList, setWorkCdList] = useState<any>([]);
  const [taskCdList, setTaskCdList] = useState<any>([]);
  const [companyList, setCompanyList] = useState<any>([]);

  const [isExtHistoryModalOpen, setIsExtHistoryModalOpen] = useState<boolean>(false);
  const [isWorkLocationModalOpen, setIsWorkLocationModalOpen] = useState<boolean>(false);

  useEffect(() => {
    codeApi.getDiscpCodeList().then((list) => {
      setDisciplineCdList(list);
      setWorkCdList([]);
      setTaskCdList([]);
    });
    companyUtil.getOptions().then((list) => {
      setCompanyList(list);
    });
  }, []);
  useEffect(() => {
    codeApi.getDiscpCodeList(props.data?.disciplineCd).then((list) => {
      setWorkCdList(list);
      setTaskCdList([]);
    });
  }, [props.data?.disciplineCd]);

  useEffect(() => {
    codeApi.getDiscpCodeList(props.data?.workCd).then((list) => {
      setTaskCdList(list);
    });
  }, [props.data?.workCd]);

  useEffect(() => {
    if (!props.data) {
      props.setData((prev: any) => ({
        ...prev,
        workRisk: 'GENERAL'
      }));
    }
  }, [props.data]);

  useEffect(() => {
    if (!props.data?.approvalMVOList || props.data?.approvalMVOList.length == 0) {
      ptwApi.getEmptyApprovalData({ formCode: props.formCode }).then((r) => {
        if (r.isSuccess) {
          const userId = user.userInfo?.userId;
          const userNm = user.userInfo?.fullName;
          const processedList = r.resultList.map((item: any, index: number) => {
            if (index === 0 && item.approverCategory === 'Performing Authority') {
              return { ...item, ptwPageApprovalDVOList: [{ userId, userNm }] };
            }
            return item;
          });
          props.setData((prev: any) => ({
            ...prev,
            workRisk: 'GENERAL',
            approvalMVOList: [...processedList]
          }));
        }
      });
    }
  }, [props.data?.approvalMVOList]);

  const workLocationCallback = (location: any, locationText: any) => {
    props.handleChange({
      target: {
        name: 'location',
        value: location,
        type: 'json'
      }
    });
    props.handleChange({
      target: {
        name: 'locationText',
        value: locationText
      }
    });
    setIsWorkLocationModalOpen(false);
  };

  return (
    <>
      <WorkLocationModal
        setIsModalOpen={setIsWorkLocationModalOpen}
        isModalOpen={isWorkLocationModalOpen}
        onActionCallback={workLocationCallback}
        location={props.data?.location}
        locationText={props.data?.locationText}
        enableDrawLine={true}
      />
      <div className={'cold-detail'}>
        {props.data?.approvalStatus === 'CANCEL' && (
          <div className="cancel-area">
            <img src={DashIcon} alt="ban icon" className="cancel-icon" />
            <div className="cancel-content-area">
              <div className="cancel-title">
                <span className="cancel-title-text">Permit Cancelled</span>
              </div>
              <div className="cancel-content">
                <div className="cancel-content-detail">
                  <span className="cancel-content-name">{props.data?.cancellerNm}</span>
                  <span>·</span>
                  <span className="cancel-content-comment">{props.data?.cancelComment}</span>
                </div>
                <div className="cancel-date">
                  <img src={ActionClock} alt="ban icon" className="action-icon" />
                  <span>{dateUtil.formatDate(props.data?.cancelDate)}</span>
                </div>
              </div>
            </div>
          </div>
        )}
        {props.data?.extendDate && (
          <div className="extend-area">
            <ExtensionHistoryModal
              isModalOpen={isExtHistoryModalOpen}
              setIsModalOpen={setIsExtHistoryModalOpen}
              ptwDSeq={props.data?.ptwDSeq}
            />
            <img src={ClockIcon} alt="ban icon" className="extend-icon" />
            <div className="extend-content-area">
              <div className="extend-title">
                <span className="extend-title-text">Extension Approved</span>
                <button
                  className="extend-history-btn"
                  onClick={() => setIsExtHistoryModalOpen(true)}
                >
                  EXTENSION HISTORY
                </button>
              </div>
              <div className="extend-content">
                <div className="extend-content-detail">
                  <span className="extend-content-name">{props.data?.extenderNm}</span>
                  <span>·</span>
                  <span className="extend-content-comment">{props.data?.comment}</span>
                </div>
                <div className="extend-date">
                  <img src={ActionClock} alt="ban icon" className="action-icon" />
                  <span>{dateUtil.formatDate(props.data?.extendDate)}</span>
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="contents-watermark-wrapper">
          <div
            className={
              'form-contents ' +
              (props.data?.approvalStatus === 'CANCEL' ? 'form-cancel-watermark' : '')
            }
          >
            {props.tbmNo && (
              <table className="form-table">
                <tbody>
                  <tr>
                    <th style={{ width: '300px' }}>TBM No</th>
                    <td>
                      <CustomText
                        onChange={props.handleChange}
                        name={'tbmNo'}
                        className={'form'}
                        readOnly={true}
                        value={props.tbmNo}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            )}
            {/* renew로 생성시킨 데이터 */}
            {props.data?.refPtwDSeq && (
              <>
                <div className={'form-sub-title'}>Renewal Reference</div>
                <table className={'form-table'}>
                  <tbody>
                    <tr>
                      <th className={'form-required'} style={{ width: '300px' }}>
                        Renewed from Permit No
                      </th>
                      <td>
                        <CustomText
                          onChange={props.handleChange}
                          name={'refPtwNo'}
                          className={'form'}
                          readOnly={true}
                          value={props.data?.refPtwNo}
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </>
            )}
            <table className={'form-table'}>
              <tbody>
                <tr>
                  <th style={{ width: '300px' }}>Road Closure Permit Number</th>
                  <td>
                    <CustomText
                      onChange={props.handleChange}
                      name={'ptwNo'}
                      className={'form'}
                      readOnly={true}
                      value={props.data?.ptwNo}
                    />
                  </td>
                </tr>
                <tr>
                  <th>Submitted date</th>
                  <td>
                    <CustomDate
                      name={'permitDate'}
                      className={'form'}
                      onChange={props.handleChange}
                      value={props.data?.permitDate}
                      disabled={props.isReadOnly}
                      defaultValue={new Date()}
                    />
                  </td>
                </tr>
              </tbody>
            </table>

            <div className={'form-sub-title'}>TASK & WORK DESCRIPTION</div>
            <table className={'form-table'}>
              <tbody>
                <tr>
                  <th className={'form-required'} style={{ width: '300px' }}>
                    Work Risk
                  </th>
                  <td>
                    <div className={'flex-row flex-row-center gap-2'}>
                      {props.data?.workRisk === 'GENERAL' && (
                        <CustomButton
                          text={'General Work'}
                          className={'grid-button blue cursor-none'}
                        />
                      )}
                      {props.data?.workRisk === 'HIGH' && (
                        <CustomButton
                          text={'High-Risk Work'}
                          className={'form-button red cursor-none'}
                        />
                      )}
                    </div>
                  </td>
                </tr>
                <tr>
                  <th className={'form-required form-required'}>Work Location / Area</th>
                  <td>
                    <div className={'group-td-column'}>
                      <CustomText
                        name={'locationText'}
                        className={'form'}
                        value={props.data?.locationText}
                        isBtnSearch={!props.isReadOnly}
                        onSearchAction={() => {
                          setIsWorkLocationModalOpen(true);
                        }}
                        readOnly={true}
                      />
                      <PermitIssueMap
                        location={props.data?.location}
                        onChange={props.handleChange}
                        isRoadClosure={true}
                      />
                    </div>
                  </td>
                </tr>
                <tr>
                  <th className={'form-required'} style={{ width: '300px' }}>
                    Company
                  </th>
                  <td>
                    <CustomSelectSingle
                      name={'companyId'}
                      className={'form'}
                      onChange={props.handleChange}
                      value={props.data?.companyId}
                      options={companyList}
                      readOnly={props.isReadOnly}
                    />
                  </td>
                </tr>
                <tr>
                  <th>Register</th>
                  <td>
                    <CustomText
                      name={'receiverNm'}
                      className={'form'}
                      readOnly={true}
                      value={props.data?.receiverNm}
                      defaultValue={props.userInfo.fullName}
                      onChange={props.handleChange}
                    />
                  </td>
                </tr>

                <tr>
                  <th className={'form-required'}>Sub Contractor</th>
                  <td>
                    <CustomText
                      name={'subcontractor'}
                      className={'form'}
                      onChange={props.handleChange}
                      value={props.data?.subcontractor}
                      readOnly={props.isReadOnly}
                      defaultValue={props.userInfo?.companyName}
                    />
                  </td>
                </tr>
                <tr>
                  <th className={'form-required'}>Expected Closure Period</th>
                  <td>
                    <div className={'group-td-row'}>
                      <CustomDatetime
                        name={'validStartTime'}
                        className={'form'}
                        onChange={props.handleChange}
                        value={props.data?.validStartTime}
                        disabled={props.isReadOnly}
                        defaultValue={dateUtil.getTodayMorning7()}
                      />
                      <span>-</span>
                      <CustomDatetime
                        name={'validEndTime'}
                        className={'form'}
                        onChange={props.handleChange}
                        value={props.data?.validEndTime}
                        disabled={props.isReadOnly}
                        defaultValue={dateUtil.getAfterMonth19()}
                        isLimitMonth
                      />
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>Tesk Description</th>
                  <td>
                    <CustomTextarea
                      name={'description'}
                      className={'form'}
                      onChange={props.handleChange}
                      value={props.data?.description}
                      disabled={props.isReadOnly}
                    />
                  </td>
                </tr>
              </tbody>
            </table>
            <PermitIssueForm
              formCode={props.formCode}
              handleChange={props.handleChange}
              data={props.data}
              isReadOnly={props.isReadOnly}
            />
            <div className={'form-sub-title'}>APPROVAL/CONFIRMATION</div>
            <FormApproval
              data={props.data}
              setData={props.setData}
              handleChange={props.handleChange}
              formCode={props.formCode}
              isReadOnly={props.isReadOnly}
              isFinish={props.isFinish}
            />
            <div className={'form-sub-title'}>Special Instruction</div>
            <div style={{ width: '100%' }}>
              <CustomTextarea
                name={'specialInstruction'}
                className={'form'}
                onChange={props.handleChange}
                value={props.data?.specialInstruction}
                placeholder={'* Please note in this column if the activity cancel'}
                isReload={true}
                disabled={props.isReadOnly}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Form04RoadDetail;
